import * as React from 'react';
import { Link } from 'react-router-dom';

import { TitleBar } from '@/components/Common';
import { paths } from '@/config';

function RegisterPayment(props) {
  return (
    <div>
      {props.code === 'accountAndCard' ? (
        <>
          <TitleBar title="魚を出品するには" />
          <div className="register-process">
            <div className="process-list">
              <div className="process-content">
                1.
                <Link to={paths.mypage.credit_register}>
                  &nbsp;クレジットカード・デビットカード情報を登録
                </Link>
                してください。
              </div>
              <div className="process-content">
                2.
                <Link to={paths.mypage.bank_account}>
                  &nbsp;売上げ受取口座情報を登録
                </Link>
                してください。
              </div>
              <div className="process-content">
                3. 写真・詳細情報を入力してオークションにカンタン出品！
              </div>
              <div className="process-remarks">
                ※ カード・口座の情報は2回目以降も保持されます
              </div>
            </div>
          </div>
        </>
      ) : props.code === 'card' ? (
        <div className="selling-requirements">
          <div>クレジットカード・デビットカードが登録されていません。</div>
          <div>
            出品するには、マイページより
            <Link to={paths.mypage.credit_register}>
              クレジットカード・デビットカードの登録
            </Link>
            が必要です。
          </div>
        </div>
      ) : props.code === 'account' ? (
        <div className="selling-requirements">
          <div>売上げ受取口座が登録されていません。</div>
          <div>
            出品するには、マイページより
            <Link to={paths.mypage.bank_account}>売上げ受取口座の登録</Link>
            が必要です。
          </div>
        </div>
      ) : props.code === 'accountIncomplete' ? (
        <div className="selling-requirements">
          <div>売上げ受取口座の登録が完了していません。</div>
          <div>
            このままでは売上金をお受け取りいただけないため、出品できません。
            マイページより
            <Link to={paths.mypage.bank_account}>口座登録の再開</Link>
            を行ってください。
          </div>
        </div>
      ) : props.code === 'accountUnderReview' ? (
        <div className="selling-requirements">
          <div>Stripeの口座登録審査中です。</div>
          <div>
            審査が完了すると出品いただけます。状況は
            <Link to={paths.mypage.bank_account}>売上げ受取方法</Link>
            からご確認ください。
          </div>
        </div>
      ) : null}
    </div>
  );
}
export default RegisterPayment;
